'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Dipasang di landing page publik ('/'). Pengunjung anonim (termasuk Googlebot)
 * dibiarkan melihat konten landing agar bisa di-index. User yang SUDAH login
 * langsung diarahkan ke tujuan sesuai statusnya (pilih tenant / onboarding / dashboard).
 */
export default function AuthedRedirect() {
  const { isAuthenticated, isLoading, needsTenantSelection, needsOnboarding, homePath } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    if (needsTenantSelection) {
      router.replace('/pilih-perusahaan');
    } else if (needsOnboarding) {
      router.replace('/onboarding');
    } else {
      router.replace(homePath);
    }
  }, [isAuthenticated, isLoading, needsTenantSelection, needsOnboarding, homePath, router]);

  return null;
}
